<template>
  <div id="app">
    <b-alert variant="default" class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000;padding-bottom:10px;background:white" show v-show="socketstatus == 'Disconnected' && userLoggedIn"><b>Not Connected. </b><a style="text-decoration:underline" @click="SocketConnection()">Try Again</a></b-alert>
    <b-alert variant="default" class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000;padding-bottom:10px;background:white" show v-show="socketstatus == 'Connecting' && userLoggedIn"><b>Connecting...</b></b-alert>
    <div v-if="userLoggedIn">

        <!-- Change Password Modal -->
        <b-modal  content-class="modal-st" size="lg" id="password-modal" centered="true" hide-footer>
            <template v-slot:modal-title>
              Change Password ({{user.Email}})
            </template>
            <div class="d-block text-center scrollbar" id="style-4" style="max-height:100vh;overflow-y:auto;">
              <ResetPassword />
            </div>
        </b-modal>

        <div class="layout">
          <div class="content kingcontent" v-show="siteLoading">
              <div class="kingloader"><b-spinner style="width: 4rem; height: 4rem;color: #346168!important;" variant="primary" label="Text Centered"></b-spinner></div>
          </div>
          <div class="content" id="Container" v-if="!siteLoading" style="padding:0px !important">     
              <md-app md-waterfall md-mode="fixed-last" style="width:100vw;position:fixed;">
                <md-app-toolbar class="md-large md-dense" style="min-height: 36px;background-color: #073c49">
                  <div class="md-toolbar-row">
                    <div class="md-toolbar-section-start">
                      <!--<md-button class="md-icon-button" @click="menuVisible = !menuVisible">
                        <md-icon style="color:#ffffff">menu</md-icon>
                      </md-button>-->

                      <!-- Hide belo line for LSB deployment --> 
                      <span style="color:white" class="md-title">{{$mainDomain}}</span>
                    </div>
                   
                    <div class="md-toolbar-row" style="overflow: hidden;background-color: #073c49">
                      <md-tabs class="md-transparent" :md-active-tab="currenttab" @md-changed="changedTab()">
                        <template slot="md-tab" slot-scope="{ tab }">
                          {{ tab.label }} <md-icon v-if="tab.label != 'My Projects'">close</md-icon><i class="badge" v-if="tab.data.badge">{{ tab.data.badge }}</i><md-tooltip>{{ tab.data.maintitle }}</md-tooltip>
                        </template>
                        <md-tab @click="showMyProjects()" id="My Projects" md-label="My Projects" :md-template-data="{ badge : notification_count, maintitle : 'My Projects'}"></md-tab>
                        <md-tab v-if="t.Open" v-for="t in allprojects" :md-template-data="{ badge: t.Unread_discussions, maintitle : t.API_title}"  :md-label="t.Trimmed_title"  :id="t.Trimmed_title" @click="openTrack(t)"></md-tab>
                      </md-tabs>
                    </div>
          
                    <div class="md-toolbar-section-end">
                      <!--<md-badge v-show="notification_count != 0" :md-content="notification_count" md-dense style="margin-right:10px;">
                        <md-button @click="ShowProjects()">
                          All Projects<md-icon style="color: #ffffff">chevron_right</md-icon>
                        </md-button>
                      </md-badge>
                      <md-button @click="ShowProjects()" v-show="notification_count == 0">
                         All Projects
                      </md-button>-->
                      <md-button @click="ShowSearch()" class="md-icon-button box-end">
                        <md-icon style="color: #ffffff">search</md-icon>
                      </md-button>
                      <md-button class="md-icon-button">
                        <md-menu md-size="medium" md-align-trigger>
                          <md-button md-menu-trigger><md-icon style="color: #ffffff">person</md-icon></md-button>
                          <md-menu-content>
                            <!--<md-menu-item class="menuitem"><k class="newcolor">My Profile</k></md-menu-item>-->
                            <md-menu-item class="menuitem" @click="tostudio()"><k class="newcolor">{{$mainDomain}} Studio</k></md-menu-item>
                            <!--<md-menu-item class="menuitem"><k class="newcolor">Settings</k></md-menu-item>-->
                            <md-menu-item class="menuitem" @click="passwordview()"><k class="newcolor">Change Password</k></md-menu-item>
                            <md-menu-item class="menuitem" @click="logout()"><k class="newcolor">Logout</k></md-menu-item>
                          </md-menu-content>
                        </md-menu>
                      </md-button>
                    </div>
                  </div>
          
                  
                </md-app-toolbar>

                <md-app-content v-show="!showsearch && showsearchProjects" style="padding:0px;margin-left:-60px;background-color: #e6efee !important;height:100vh">
                  <SearchProject msg="Showing Projects"  v-bind:searchprojects="projects" />
                </md-app-content>

                <md-app-content v-show="showsearch && !showsearchProjects" style="padding:0px;margin-left:-60px;">
                   <Search msg="Welcome to Your Vue.js App"/>
                </md-app-content>

                <md-app-drawer v-show="!showsearch && !showsearchProjects" :md-active.sync="menuVisible" md-persistent="mini" style="overflow-y: hidden;background-color: #073c49;width:60px !important;">
                  <md-toolbar class="md-transparent" md-elevation="0" >
                    <span>Navigation</span>
                
                    <div class="md-toolbar-section-end">
                      <md-button class="md-icon-button md-dense">
                        <md-icon>keyboard_arrow_left</md-icon>
                      </md-button>
                    </div>
                  </md-toolbar>

                  <md-list style="padding:0px;background-color: #073c49" v-show="myprojectsShow">
                    <md-list-item class="side-btn-item-active">
                          <md-menu class="side-md-menu">
                          <md-button class="md-icon-button md-primary"  md-menu-trigger>
                              <md-icon class="side-btn-active-color">home</md-icon>
                          </md-button>
                          </md-menu>
                      </md-list-item>
                  </md-list>
                
                  <md-list style="padding:0px;background-color: #073c49" v-show="!myprojectsShow">
                    <md-list-item v-bind:class="[{'side-btn-item-active' : side_name == 'home', 'side-btn-item' : side_name != 'home'}]">
                          <md-menu class="side-md-menu">
                          <md-button @click="ShowHome()" v-bind:class="['md-icon-button md-primary', {'side-btn-active' : side_name == 'home', 'side-btn' : side_name != 'home'}]"  md-menu-trigger>
                              <md-icon v-bind:class="[{'side-btn-active-color' : side_name == 'home', 'side-btn-color' : side_name != 'home'}]">home</md-icon>
                          </md-button>
                          </md-menu>
                      </md-list-item>
                      <md-list-item v-bind:class="[{'side-btn-item-active' : side_name == 'chart', 'side-btn-item' : side_name != 'chart'}]">
                          <md-menu class="side-md-menu">
                          <md-button @click="ShowPlot()"  v-bind:class="['md-icon-button md-primary', {'side-btn-active' : side_name == 'chart', 'side-btn' : side_name != 'chart'}]"  md-menu-trigger>
                              <md-icon  v-bind:class="[{'side-btn-active-color' : side_name == 'chart', 'side-btn-color' : side_name != 'chart'}]">insert_chart_outlined</md-icon>
                          </md-button>
                          </md-menu>
                      </md-list-item>
                      <md-list-item v-bind:class="[{'side-btn-item-active' : side_name == 'insights', 'side-btn-item' : side_name != 'insights'}]">
                        <md-menu class="side-md-menu">
                          <md-button  @click="ShowAnalysis()" v-bind:class="['md-icon-button md-primary', {'side-btn-active' : side_name == 'insights', 'side-btn' : side_name != 'insights'}]"  md-menu-trigger>
                            <md-icon  v-bind:class="[{'side-btn-active-color' : side_name == 'insights', 'side-btn-color' : side_name != 'insights'}]">insights</md-icon>
                          </md-button>
                        </md-menu>
                      </md-list-item>
                      <md-list-item v-bind:class="[{'side-btn-item-active' : side_name == 'people', 'side-btn-item' : side_name != 'people'}]">
                        <md-menu class="side-md-menu">
                          <md-button  @click="ShowUser()" v-bind:class="['md-icon-button md-primary', {'side-btn-active' : side_name == 'people', 'side-btn' : side_name != 'people'}]"  md-menu-trigger>
                            <md-icon  v-bind:class="[{'side-btn-active-color' : side_name == 'people', 'side-btn-color' : side_name != 'people'}]">people</md-icon>
                          </md-button>
                        </md-menu>
                      </md-list-item>
                      <md-list-item v-bind:class="[{'side-btn-item-active' : side_name == 'tasks', 'side-btn-item' : side_name != 'tasks'}]">
                        <md-menu class="side-md-menu">
                          <md-button  @click="ShowNewTaskManager()" v-bind:class="['md-icon-button md-primary', {'side-btn-active' : side_name == 'tasks', 'side-btn' : side_name != 'tasks'}]"  md-menu-trigger>
                            <md-icon  v-bind:class="[{'side-btn-active-color' : side_name == 'tasks', 'side-btn-color' : side_name != 'tasks'}]">pending_actions</md-icon>
                          </md-button>
                        </md-menu>
                      </md-list-item>
                      <md-list-item v-bind:class="[{'side-btn-item-active' : side_name == 'files', 'side-btn-item' : side_name != 'files'}]">
                        <md-menu class="side-md-menu">
                          <md-button  @click="ShowFileBrowser()" v-bind:class="['md-icon-button md-primary', {'side-btn-active' : side_name == 'files', 'side-btn' : side_name != 'files'}]"  md-menu-trigger>
                            <md-icon  v-bind:class="[{'side-btn-active-color' : side_name == 'files', 'side-btn-color' : side_name != 'files'}]">create_new_folder</md-icon>
                          </md-button>
                        </md-menu>
                      </md-list-item>
                    <!--<md-list-item>
                          <md-menu>
                          <md-button class="md-icon-button md-primary" md-menu-trigger>
                              <md-icon style="color:#ffffff">assignment</md-icon>
                          </md-button>
                          </md-menu>
                      </md-list-item>
                    
                    <md-list-item>
                      <md-menu>
                        <md-button class="md-icon-button md-primary" md-menu-trigger>
                          <md-icon style="color:#ffffff">edit</md-icon>
                        </md-button>
                      </md-menu>
                    </md-list-item>
                    <md-list-item>
                      <md-menu>
                        <md-button class="md-icon-button md-primary" md-menu-trigger>
                          <md-icon style="color:#ffffff">archive</md-icon>
                        </md-button>
                      </md-menu>
                    </md-list-item>
                    <md-list-item>
                      <md-menu>
                        <md-button class="md-icon-button md-primary" md-menu-trigger>
                          <md-icon style="color:#ffffff">push_pin</md-icon>
                        </md-button>
                      </md-menu>
                    </md-list-item>-->
                  </md-list>
                </md-app-drawer>
          
                <md-app-content  v-show="!showsearch && !showsearchProjects" id="style-4" style="background-color:#153c49;padding:0px;padding-bottom:100vh;">
                  <router-view></router-view>
                  <nprogress-container></nprogress-container>
                </md-app-content>
              </md-app>        
          </div>
        </div>
    </div>
    <div v-if="!userLoggedIn && !siteLoading">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  require('@/assets/css/pienomial.css')
  import axios from 'axios'
  import { EventBus } from './event-bus.js'
  import Vue from 'vue'
  import Search from '@/components/Search.vue'
  import SearchProject from '@/components/searchProject.vue'
  import ResetPassword from "@/components/changepassword.vue"
  import Router from 'vue-router'
  import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
  
  
  export default {
    data () {
      return {
        onLine: navigator.onLine,
        auth_token: '',
        user: '',
        userID:'',
        socketstatus : 'connection',
        userLoggedIn:false,
        projects : [],
        selectedchatmessages : {"Forms" : []},
        search:"",
        listsearch:"",
        messagecounts : {},
        SelectedMenuProject : {},
        siteLoading : true,
        side_name : 'home',
        project_loaded : false,
        showsearch:false,
        showsearchProjects :false,
        rearranged : true,
        notification_count : 0,
        refreshed_token : 0,   //To Route after reloading...
        myprojectsShow:false,
        discussions_recieved : [],
        ShowP : false,
        showAnalytics : false,
        currenttab : "My Projects",
        routeLoading : false,
      }
    },
    watch: {
        onLine(v) {
          console.log(v)
            if (v) {
              this.SocketConnection()
            }else{
              this.socketstatus = "Disconnected"
            }
        },
        routeLoading(v){

        }
    },
    components: {
      Search, SearchProject, NprogressContainer,ResetPassword
    },
    computed: {
        listprojects(){
          if(this.projects.length <= 0){
            return []
          }
          var a = []
          for (let i = 0; i < this.projects.length; i++) {
              const element = this.projects[i];
              var k = {}
              k.Project_name = element.API_title
              k.APItoken = element.APItoken
              if(element.API_title.toLowerCase().includes(this.search.toLowerCase())){
                a.push(k)
              }
          }
          return a
        },
        allprojects(){
          //console.log(this.projects)
            if(this.projects.length <= 0){
                return []
            }
            return this.projects.filter(post => {
              if(post.Open && this.rearranged){
                post.ID = post.APItoken
                let checktag = false
                if(post.Tags != null && post.Tags.length > 0){
                    for(let x = 0; x < post.Tags.length; x++) {
                      const element = post.Tags[x];
                      checktag = element.toLowerCase().includes(this.search.toLowerCase())
                      if (checktag){
                        break
                      }
                    }
                } 
                post.Trimmed_title = post.API_title
                if(post.Trimmed_title.length > 25){
                  post.Trimmed_title = post.Trimmed_title.substring(0, 22) + "..";
                }
                if(post.API_title != ""){
                  return post.API_title.toLowerCase().includes(this.search.toLowerCase()) || checktag
                }else{
                  return post.Project_name.toLowerCase().includes(this.search.toLowerCase()) || checktag
                }
              } 
            })
        },
    },
    watch: {
      $route(to, from) {
        this.zerostate()
        if(this.SelectedMenuProject.Trimmed_title != undefined){
          this.currenttab = this.SelectedMenuProject.Trimmed_title
        }
        if(to.fullPath.includes("ChatDesign")){
          this.side_name = "home" 
          this.refreshed_token = this.$route.query.api
          console.log(this.refreshed_token)
        }else if(to.fullPath.includes("Plot")){
          this.side_name = "chart"
          this.refreshed_token = this.$route.query.api
        }else if(to.fullPath.includes("Dashboard")){
          this.side_name = "home"
          this.myprojectsShow = true
          this.currenttab = "My Projects"
        }else if(to.fullPath.includes("User")){
          this.side_name = "people"
          this.refreshed_token = this.$route.query.api
        }else if(to.fullPath.includes("Tasks")){
          this.side_name = "tasks"
          this.refreshed_token = this.$route.query.api
        }else if(to.fullPath.includes("Files")){
          this.side_name = "files"
          this.refreshed_token = this.$route.query.api
        }else if(to.fullPath.includes("Analysis")){
          this.side_name = "insights"
          this.refreshed_token = this.$route.query.api
        }
        this.routeLoading = true
        console.log("Routing??")
      }
    },
    created () {
      //Firebase Code
      this.$messaging.onMessage(function(payload) {
        console.log("Message received.", payload);
        //EventBus.$emit('new-message', payload)
      });

      EventBus.$on('login', token => {
        this.siteLoading = true
        this.getUser(token, "true")
      })
      EventBus.$on('template_login', token => {
        this.getUser(token, "false")
      })
      EventBus.$on('socket_disconnected', token => {
          this.socketstatus = "Disconnected"
      })
      EventBus.$on('socket_message', token => {
        this.newsocketMessage(token)
      })
      EventBus.$on('socket_connected', token => {
        this.socketstatus = "connection"
      })
      EventBus.$on('closeSearch', token => {
        this.showsearch = false
        this.showsearchProjects = false
      })
      EventBus.$on('loadDiscussionView', apitoken => {
        this.LoadView(apitoken, "home")
      })
      EventBus.$on('loadplotView', apitoken => {
        this.LoadView(apitoken, "chart")
      })
      EventBus.$on('loadAnalyticsView', apitoken => {
        this.LoadView(apitoken, "insights")
      })
      EventBus.$on('loadTaskView', apitoken => {
        this.LoadView(apitoken, "tasks")
      })
      EventBus.$on('loadFilesView', apitoken => {
        this.LoadView(apitoken, "files")
      })
      EventBus.$on('loadUsersView', apitoken => {
        this.LoadView(apitoken, "people")
      })
      EventBus.$on('OpenDiscussion', data => {
        this.LoadDiscussusion(data)
      })
      EventBus.$on('ReadDiscussion', data => {
        this.MarkReadDiscussion(data)
      })
      EventBus.$on('closePassModal', data => {
         this.$bvModal.hide("password-modal")
      })
      EventBus.$on('logout', token => {
        this.logout()
      })
      this.inactivityTime()
    },
    async mounted() {
      window.addEventListener('online', this.updateOnlineStatus);
      window.addEventListener('offline', this.updateOnlineStatus);
      var ContinueWithFlow = await this.LogOutAfter24Hours()
      if (ContinueWithFlow){
        this.auth_token = localStorage.getItem('authtoken')
        if (this.auth_token !== null && this.auth_token !== 'undefined' && this.auth_token !== '') {
          this.routeLoading = true
          axios.defaults.headers.common['Authorization'] = this.auth_token
          this.getUser(this.auth_token, "false")
          this.SocketConnection()
        }else{
          this.userLoggedIn = false
          this.siteLoading = false
        }
      }else{
        this.userLoggedIn = false
        this.siteLoading = false
        this.logout()
      }
    },
    methods: {
      zerostate(){
        this.showsearch = false
        this.showsearchProjects = false
        this.myprojectsShow = false
        this.$forceUpdate()
      },
      newsocketMessage(data){
        if(data.newdata != undefined){
          EventBus.$emit('new-data', data)
        }
        if (data.message != undefined){
          EventBus.$emit('new-message', data)
        }
        if(data.discussion != undefined){
          if(data.discussion != ""){
            var res = data.discussion.split("_");
            if (res.length == 2){
              for (let i = 0; i < this.projects.length; i++) {
                if(this.projects[i].APItoken.toString() == res[0]){
                  if(this.SelectedMenuProject.APItoken != undefined && this.SelectedMenuProject.APItoken.toString() == res[0]){
                    if (this.discussions_recieved.length > 0 && this.discussions_recieved.includes(res[1])){
                      return
                    }else{
                      this.projects[i].Unread_discussions += 1
                      if(isNaN(this.notification_count)){
                        this.notification_count = 0
                      }
                      this.notification_count += 1
                      this.discussions_recieved.push(res[1])
                      EventBus.$emit('new-discussion', res)
                    }
                  }else{
                    if(isNaN(this.notification_count)){
                      this.notification_count = 0
                    }
                    this.notification_count += 1
                    EventBus.$emit('new-discussion', res)
                  }
                  break
                }
              }
            }
          }
        }
        if(data.discussion_remove != undefined){
          if(data.discussion_remove != ""){
            var res = data.discussion_remove.split("_");
            if (res.length == 2){
              for (let i = 0; i < this.projects.length; i++) {
                if(this.projects[i].APItoken.toString() == res[0]){
                  if(this.SelectedMenuProject.APItoken != undefined && this.SelectedMenuProject.APItoken.toString() == res[0]){
                    EventBus.$emit('remove-discussion', res)
                  }
                }
              }
            }
          }
        }
      },
      sortList(apitoken){
        this.SelectedMenuProject = {}
        this.refreshed_token = 0
        this.rearranged = false
        this.showsearchProjects = false
        console.log(a_name)
        let a_name = ""
        for (let i = 0; i < this.projects.length; i++) {
          if (this.projects[i].APItoken == parseInt(apitoken)){
            this.projects[i].Message_time = new Date()
            this.projects[i].Open = true
            this.SelectedMenuProject = this.projects[i]
            a_name = this.projects[i].Trimmed_title
            break
          }
        }
        this.projects.sort((a, b) => new Date(b.Message_time) - new Date(a.Message_time))
        let app = this  
        setTimeout(function(){ 
          app.rearranged = true
        }, 20); 
        this.currenttab = a_name
        console.log(a_name)
        this.$forceUpdate()
      },
      LoadDiscussusion(data){
        console.log(data, "open discussion")
        let array = data.split("_")
        let apitoken = array[0]
        let disc_id = array[1]
        this.refreshed_token = disc_id
        this.rearranged = false
        this.showsearchProjects = false
        var project = {}

        let a_name = ""
        for (let i = 0; i < this.projects.length; i++) {
          if (this.projects[i].APItoken == parseInt(apitoken)){
            this.projects[i].Message_time = new Date()
            this.projects[i].Open = true
            a_name = this.projects[i].API_title
            project = this.projects[i]
            break
          } 
        }
        this.projects.sort((a, b) => new Date(b.Message_time) - new Date(a.Message_time))
        let app = this  
        setTimeout(function(){ 
          app.rearranged = true
        }, 20); 
        this.showsearch = false
        this.showsearchProjects = false
        this.SelectedMenuProject = project
        this.SelectedMenuProject.ID = this.SelectedMenuProject.APItoken
        this.markDiscussionRead()
        this.currenttab = project.Trimmed_title
        console.log(this.side_name)
        this.side_name  = 'home'
        if (this.refreshed_token == 0){
          this.$router.push('/ChatDesign?api='+this.SelectedMenuProject.APItoken, () => {})
        }else{
          this.$router.push('/ChatDesign?api='+this.SelectedMenuProject.APItoken+"&did="+this.refreshed_token, () => {})
          this.refreshed_token = 0
        }
        this.$forceUpdate() 
      },
      LoadView(data, view){
        let apitoken = data
        this.rearranged = false
        this.showsearchProjects = false
        var project = {}
        let a_name = ""
        for (let i = 0; i < this.projects.length; i++) {
          if (this.projects[i].APItoken == parseInt(apitoken)){
            this.projects[i].Message_time = new Date()
            this.projects[i].Open = true
            a_name = this.projects[i].API_title
            project = this.projects[i]
            break
          } 
        }
        //this.ShowP = true
        this.projects.sort((a, b) => new Date(b.Message_time) - new Date(a.Message_time))
        let app = this  
        setTimeout(function(){ 
          app.rearranged = true
        }, 20); 

        this.page = 1
        this.showsearch = false
        this.showsearchProjects = false
        this.SelectedMenuProject = project
        this.SelectedMenuProject.ID = this.SelectedMenuProject.APItoken
        this.markDiscussionRead()
        this.currenttab = project.Trimmed_title
        if(view == "chart"){
          this.side_name = "chart"
          this.$router.push('/Plot?api='+this.SelectedMenuProject.APItoken, () => {})
        }else if (view == "insights"){
          this.side_name = "insights"
          this.$router.push('/Analysis?api='+this.SelectedMenuProject.APItoken, () => {})
        }else if (view == "home"){
          this.side_name = "home"
          this.$router.push('/ChatDesign?api='+this.SelectedMenuProject.APItoken, () => {})
        }else if (view == "tasks"){
          this.side_name = "tasks"
          this.$router.push('/Tasks?api='+this.SelectedMenuProject.APItoken, () => {})
        }else if (view == "files"){
          this.side_name = "files"
          this.$router.push('/Files?api='+this.SelectedMenuProject.APItoken, () => {})
        }else if (view == "people"){
          this.side_name = "files"
          this.$router.push('/User?api='+this.SelectedMenuProject.APItoken, () => {})
        }
        this.$forceUpdate()
      },
      logout(){
        //Socket disconnection
        delete this.$options.sockets.onmessage
        this.$disconnect()

        //gAuth Removal
        this.$gAuth
        .signOut()
        .then(() => {
          this.isSignIn = this.$gAuth.isAuthorized;
        })
        .catch(error => {
          //on fail do something
        });

        //Auth Token Removal
        localStorage.removeItem('authtoken')
        delete axios.defaults.headers.common['Authorization']

        //Firebase Removal
        var req = indexedDB.deleteDatabase("fcm_token_details_db");
        req.onsuccess = function () {
          console.log("Deleted database successfully");
        };
        req.onerror = function () {
            console.log("Couldn't delete database");
        };
        req.onblocked = function () {
            console.log("Couldn't delete database due to the operation being blocked");
        };
        var req = window.indexedDB.deleteDatabase("fcm_vapid_details_db");
        req.onsuccess = function () {
            console.log("Deleted database successfully");
        };
        req.onerror = function () {
            console.log("Couldn't delete database");
        };
        req.onblocked = function () {
            console.log("Couldn't delete database due to the operation being blocked");
        };
        var request = indexedDB.open("fcm_token_details_db");
        request.onsuccess = function(event) {
          var db = event.target.result;
          db.onversionchange = function(event) {
            console.log("version change")
            event.target.close();
          }
        }
        var localdata = JSON.parse(localStorage.getItem('mahiti'))
        if (localdata != null && localdata.length > 0){
          axios.put('/deletefcmtoken?fcmtoken='+localdata[1]).then(res => {
            if (res.data.value !== 1) {
              console.log("Deleted Token")
            }
          })
          localStorage.removeItem("mahiti");
        }

        this.userLoggedIn = false
        this.$router.push('/')
      },
      getImgUrl() {
        var images = require.context('./assets/', false, /\.png$/)
        return images('./' + this.$mainDomain + ".png")
      },
      SocketConnection(){
        this.auth_token = localStorage.getItem('authtoken')
        this.socketstatus = "Connecting"
        this.$connect(this.$socketUrl + '?token='+this.auth_token)
      },
      getUser(token, redirect){
        this.auth_token = token
        let newthis = this
        axios.get('/getprofile?token='+token).then(res => {
          if (res.data.value !== 1) {
            this.userLoggedIn = true
            this.user = res.data
            this.userID = res.data.ID
            Vue.prototype.$User = this.user
            Vue.prototype.$AuthToken = token
            axios.defaults.headers.common['Authorization'] = token
            localStorage.setItem('authtoken', token)
            this.checkIfRouteLoaded()
            this.requestnotificationandtoken(this.userID)
          }else{
            localStorage.removeItem('authtoken')
            delete axios.defaults.headers.common['Authorization']
            this.$router.push('/')
          }
        }).catch((error) => {
            localStorage.removeItem('authtoken')
            delete axios.defaults.headers.common['Authorization']
            this.$router.push('/')
        })
      },
      updateOnlineStatus(e) {
            const {
                type
            } = e;
            this.onLine = type === 'online';
      },
      checkIfRouteLoaded(){
        var app = this
        var intervalId = setInterval(function() {
            if(app.routeLoading) {
              clearInterval(intervalId);
              app.getMainProjects()
            }
        }, 100); 
      },
      getMainProjects(){
        this.projects = []
        this.notification_count = 0
        axios.get('/getNewwebapiprojects')
        .then(res => {
            this.siteLoading = false
            if (res.data !== null && res.data.value !== 1) {
                var pro_list = []            
                for (let i = 0; i < res.data.length; i++) {
                  this.notification_count += res.data[i].Unread_discussions
                  res.data[i].API_title = res.data[i].API_title.toUpperCase()
                  res.data[i].Trimmed_title = res.data[i].API_title
                  if(res.data[i].Trimmed_title.length > 25){
                     res.data[i].Trimmed_title = res.data[i].Trimmed_title.substring(0, 22) + "..";
                  }
                  pro_list.push(res.data[i])
                }
                pro_list.sort((a, b) => new Date(b.Message_time) - new Date(a.Message_time))
                this.projects = pro_list
                if(isNaN(this.notification_count)){
                  this.notification_count = 0
                }
                var app = this
                setTimeout(function(){ 
                  if(app.refreshed_token != 0){
                    app.sortList(app.refreshed_token)
                  }
                }, 100);
               
            } else if (res.data.value === 1) {
                console.log("No projects")
            } 
        })
      },
      markRead(){
            axios.post('/markread?apitoken='+this.apitoken, {
            }).then(res => {
                this.$set(this.messagecounts, this.apitoken, 0)
            });
            //Check if USer is Collaborator
            this.adduserOpt = false
            axios.get('/userstatus?apitoken='+this.apitoken, {
            }).then(res => {
                if(res.data && res.data.value == 0){
                    this.adduserOpt = true
                }
            });
      },
      openTrack(project){

        console.log("Opening Track")

        if (this.SelectedMenuProject.ID == project.APItoken){
          //Close opened tab....
          this.rearranged = false
          for (let i = 0; i < this.projects.length; i++) {
              if(this.projects[i].APItoken.toString() == this.SelectedMenuProject.APItoken){
                this.projects[i].Open = false
                break
              }
          }
          this.SelectedMenuProject = {}
          this.projects.sort((a, b) => new Date(b.Message_time) - new Date(a.Message_time))
          var app = this
          setTimeout(function(){ 
            app.rearranged = true
          }, 20);
          setTimeout(function(){ 
            document.querySelectorAll(".md-tabs > div > button")[0].click();  
          }, 70);
        }else{
          this.page = 1
          this.showsearch = false
          this.showsearchProjects = false
          this.SelectedMenuProject = project
          this.SelectedMenuProject.ID = this.SelectedMenuProject.APItoken
          this.markDiscussionRead()

          this.currenttab = project.Trimmed_title
          this.side_name  = 'home'
          if (this.refreshed_token == 0){
            this.$router.push('/ChatDesign?api='+this.SelectedMenuProject.APItoken, () => {})
          }else{
            this.$router.push('/ChatDesign?api='+this.SelectedMenuProject.APItoken+"&did="+this.refreshed_token, () => {})
            this.refreshed_token = 0
          }
        }
      },
      markDiscussionRead(){
        /*axios.put('/markReaddiscussion?apitoken='+this.SelectedMenuProject.APItoken, {
        }).then(res => {
          if(res.data && res.data.value == 0){
            for (let i = 0; i < this.projects.length; i++) {
              if(this.projects[i].APItoken.toString() == this.SelectedMenuProject.APItoken){
                this.notification_count -= this.projects[i].Unread_discussions
                this.projects[i].Unread_discussions = 0
                break
              }
            }
          }
        });*/
      },
      MarkReadDiscussion(data){
        for (let i = 0; i < this.projects.length; i++) {
          if(this.projects[i].APItoken.toString() == data.Apitoken.toString()){
            this.notification_count -= data.Unread
            this.projects[i].Unread_discussions -= data.Unread
            if(isNaN(this.notification_count)){
              this.notification_count = 0
            }
            if(this.notification_count < 0){
              this.notification_count = 0
            }
            if(this.projects[i].Unread_discussions < 0){
              this.projects[i].Unread_discussions = 0
            }
            break
          }
        }
      },
      ShowHome(){
        if(this.SelectedMenuProject.APItoken != undefined){
          this.side_name  = 'home'
          this.$router.push('/ChatDesign?api='+this.SelectedMenuProject.APItoken)
        }
      },
      ShowPlot(){
        if(this.SelectedMenuProject.APItoken != undefined){
          this.side_name  = 'chart'
          this.$router.push('/Plot?api='+this.SelectedMenuProject.APItoken)
        }
      },
      ShowUser(){
        if(this.SelectedMenuProject.APItoken != undefined){
          this.side_name  = 'people'
          this.$router.push('/User?api='+this.SelectedMenuProject.APItoken)
        }
      },
      ShowNewTaskManager(){
        if(this.SelectedMenuProject.APItoken != undefined){
          this.side_name  = 'tasks'
          this.$router.push('/Tasks?api='+this.SelectedMenuProject.APItoken)
        }
      },
      ShowFileBrowser(){
        if(this.SelectedMenuProject.APItoken != undefined){
          this.side_name  = 'files'
          this.$router.push('/Files?api='+this.SelectedMenuProject.APItoken)
        }
      },
      ShowAnalysis(){
        if(this.SelectedMenuProject.APItoken != undefined){
          this.side_name  = 'insights'
          this.$router.push('/Analysis?api='+this.SelectedMenuProject.APItoken)
        }
      },
      ShowSearch(){
        this.showsearch = true
        this.showsearchProjects = false
        //this.$router.push('/Search?api='+this.SelectedMenuProject.APItoken)
      },
      ShowProjects(){
        this.showsearch = false
        this.showsearchProjects = true
      },
      showMyProjects(){
        this.currenttab = "My Projects"
        this.SelectedMenuProject = {}
        this.showsearch = false
        this.showsearchProjects = false
        this.$forceUpdate()
        this.$router.push('/Dashboard', () => {})
      },
      changedTab(tab){
        //console.log(tab)
      },
      inactivityTime(){
        console.log("Checking Inactive time...")
        var time;
        window.onload = resetTimer;
        document.onload = resetTimer;
        document.onmousemove = resetTimer;
        document.onmousedown = resetTimer;
        document.ontouchstart = resetTimer;
        document.onclick = resetTimer;
        document.onkeypress = resetTimer;
        document.addEventListener('scroll', resetTimer, true); 
        var app = this
        function logout() {
          console.log("TimeOut")
          app.logout()
        }
        function resetTimer() {
            clearTimeout(time);
            //30 min - 1800000 ms
            time = setTimeout(logout, 1800000)
        }
      },
      passwordview(){
        this.$bvModal.show("password-modal")
      },
      tostudio(){
        //window.location.replace("/studio")
        window.open(this.$mainUrl + "/studio", '_blank');
      },
      //Firebse Functions
      requestnotificationandtoken (userid){
        console.log("Checking Firebase..")
        var fcm_messaging = this.$messaging
        let _this = this
        fcm_messaging.requestPermission()
        .then(function() {
            fcm_messaging.getToken()
            .then(function(currentToken) {
                if (currentToken) {
                  if (localStorage.getItem("mahiti") === null) {
                    console.log("q")
                    _this.deleteFCMToken(currentToken)
                  }else{
                      console.log("2")
                    var localdata = JSON.parse(localStorage.getItem('mahiti'))
                    if (localdata.length > 0){
                      if(userid != localdata[0] || currentToken != localdata[1]){
                        console.log(currentToken)
                        console.log(localdata[1])
                        _this.deleteFCMToken(currentToken)
                      }
                    }else{
                        console.log("3")
                      _this.deleteFCMToken(currentToken)
                    }
                  }
                } else {
                    console.log("4")
                    console.log('No Instance ID token available. Request permission to generate one.');
                }
                console.log("5")
            })
            .catch(function(err) {
                console.log("6")
                console.log('An error occurred while retrieving token. ', err);
            });
        })
        .catch(function(err) {
            console.log("7")
            console.log('Unable to get permission to notify.', err);
        });
        console.log(8)
      },
      deleteFCMToken(currentToken){
        console.log("DeletingFcmToken")
        var fcm_messaging = this.$messaging
        let _this = this
        fcm_messaging.getToken().then((currentToken) => {
          fcm_messaging.deleteToken(currentToken).then(() => {
            axios.put('/deletefcmtoken?fcmtoken='+currentToken).then(res => {
              if (res.data.value !== 1) {
                console.log("Deleted Token")
                _this.getFCMToken()
              }
            })
          }).catch((err) => {
            _this.getFCMToken()
            console.log('Unable to delete token. ', err, currentToken);
          });
          // [END delete_token]
        }).catch((err) => {
          console.log('Error retrieving Instance ID token. ', err);
        });
      },
      getFCMToken(){
        let _this = this
        this.$messaging.getToken()
        .then(function(currentToken) {
          if (currentToken){
                  if (localStorage.getItem("mahiti") === null) {
                    _this.UpdateFCMTOken(currentToken)
                  }else{
                    var localdata = JSON.parse(localStorage.getItem('mahiti'))
                    if (localdata.length > 0){
                      if(_this.userID != localdata[0] || currentToken != localdata[1]){
                        _this.UpdateFCMTOken(currentToken)
                      }
                    }else{
                      _this.UpdateFCMTOken(currentToken)
                    }
                  }
                } else {
                    console.log('No Instance ID token available. Request permission to generate one.');
                }
            })
            .catch(function(err) {
                console.log('An error occurred while retrieving token. ', err);
            });
      },
      UpdateFCMTOken(fcm){
        let _this = this
        axios.post('/fcmtoken?fcmtoken='+fcm+'&platform=Web').then(res => {
          if (res.data.value !== 1) {
            console.log("Success")
            localStorage.removeItem("mahiti");
            var newdata = [_this.userID, fcm]
            localStorage.setItem("mahiti", JSON.stringify(newdata))
          }
        })
      },
      async LogOutAfter24Hours(){
        console.log("Checking last login time...")
        var last_logged_in = localStorage.getItem("ld")
        if (last_logged_in == undefined || last_logged_in == null || last_logged_in == ""){
          localStorage.setItem("ld", new Date())
          return true
        }else{
          var last_logged_in_date = new Date(last_logged_in)
          var now = Date.now();
          const oneDay = 24 * 60 * 60 * 1000;
          const isMoreThanADay = (now - last_logged_in_date) > oneDay;
          if (!isMoreThanADay){
            return true
          }
          console.log(last_logged_in_date, last_logged_in, isMoreThanADay)
        }
        return false
      }
    },
  }
</script>


<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
.kingloader{
        left: 0;
        line-height: 200px;
        margin-top: -100px;
        position: absolute;
        text-align: center;
        top: 50%;
        width: 100%;
}
 .dashboard {
    font-family: "Lato";
    font-size: 18px;
    line-height: 21.6px;
    color: #333333; 
  }
  .navstyle {
    height: 100% !important;
    border: 1px solid rgba(#000, .12) !important;
  }
  .nav-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
  }
  .md-ripple  {
    color:#ffffff;
    border-color: transparent;
  }
  .LOGO {
    width: 114.2px;
    height: 40.4px;
  }
  .newcolor{
    color:#153c49;
    font-family: Lato;
    font-size: 1.6vh;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    cursor: pointer;
  }
  .newcolor:hover{
     color:#f16722;
  }
  .md-tab-nav-button{
    background-color: #3d737b !important;
    border-radius: 10px 10px 10px 10px !important;
    margin-right:5px !important;
  }
  .md-active{
    background-color: #fff !important;
    border-radius: 10px 10px 0px 0px !important;
    margin-right:5px !important;
    color: #3d737b !important;
    height: 54px !important;
  }
  .md-active .md-button-content{
    margin-top: -5px !important;
    color: #474747 !important;
    font-weight: bold;
  }
  .md-toolbar .md-tabs {
    margin-top:10px !important;
  }
  .side-btn{
    background-image: linear-gradient(to right, #0c8e8e 21%, #0e8b8d 54%, #16828b 75%, #237489 93%, #257389 94%) !important;
    border-radius: 0px !important;
  }
  .side-btn-active{
    border-radius: 0px !important;
    background-color: #fff !important;
  }
  .side-btn-color{
    color:#fff !important;
  }
  .side-btn-active-color{
    color:#474747 !important;
  }
  .md-list-item-content{
    padding: 0px 0px -1px 16px !important;
  }
  .md-drawer.md-persistent-mini.md-left{
    border-right: none !important;
  }
  .side-btn-item-active{
    background-color: #fff !important;
    margin-bottom:1px !important;
  }
  .side-md-menu{
    margin-left:-1vh;
  }
  .side-md-menu:focus{
    margin-left:-1vh;
    outline: none !important;
  }
  .md-drawer.md-persistent-mini:not(.md-active){
    width: 60px !important;
  }
  .md-button-content:focus{
    outline: none !important;
  }
  button:focus{
    outline: none !important;
  }
  .box-end{
    box-shadow: -7px 0 5px 0 rgba(0, 0, 0, 0.3);background-color: #073c49;min-height: 64px;
    border-radius:0px !important;
  }
  .md-badge.md-dense {
    font-size: 10px !important;
  }
  .md-app-container{
    overflow:unset !important;
  }
  .md-tabs.md-theme-default .md-tabs-navigation .md-button.md-active .md-icon{
    color : #444 !important;
    display:initial !important;
    font-size: 20px !important;
  }
  .md-tabs.md-theme-default .md-tabs-navigation .md-button .md-icon{
    color : #fff !important;
    display: none !important;
  }
</style>

<style lang="scss" scoped>
  .badge {
    width: 19px;
    height: 19px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 2px;
    right: 2px;
    background: red;
    border-radius: 100%;
    color: #fff;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -.05em;
    font-family: 'Roboto Mono', monospace;
  }
</style>
